import { Box, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { getColor } from "../color/color";
import { fonts } from "../fonts/fonts";

export const TitleTypography = styled(Typography)(({ theme }) => ({
  fontWeight: 800,
  fontSize: "25px",
  fontFamily: fonts.manrope,
  textAlign: "center",
  lineHeight: "27px",
  color: getColor.SecondaryMidnightBlue,
}));
export const SubTitleTypography = styled(Typography)(({ theme }) => ({
  width: "100%",
  fontWeight: 500,
  fontSize: { xs: "14px", md: "13px" },
  lineHeight: "20px",
  marginTop: "15px",
  marginBottom: "18px",
  fontFamily: fonts.manrope,
}));

export const StyledBottomBox = styled(Box)(({ theme }) => ({
  display: "flex",
  marginTop: "17%",
  padding: "10px",
  borderRadius: "16px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: getColor.ExtendedpalettesIrishGreenIG200,
}));
export const StyledBottomText = styled(Box)(({ theme }) => ({
  fontFamily: fonts.manrope,
  marginLeft: theme.spacing(1),
  fontSize: "12px",
  color: getColor.SecondaryIrishGreen,
}));

export const StyledACRButton = {
  width: "100%",
  maxWidth: "350px",
  backgroundColor: getColor.ColorButtonPrimarysurface,
  color: getColor.PrimaryWhite,
  borderRadius: "40px",
  p: "20px",
  marginTop: "40px",
  lineHeight: "22.2px",
  fontWeight: 700,
  fontSize: "16px",
  textAlign: "center",
  textTransform: "capitalize",
};
